"use client";

import React from "react";
import Link from "next/link";
import PropTypes from "prop-types";
import { useTranslations } from "next-intl";

const PointsSection = () => {
  const t = useTranslations("HomePageFlights.PointsSection");

  return (
    <div className="w-full min-h-50vh flex justify-center p-3 md:p-4 pt-2 md:pt-3 pb-2 md:pb-3 bg-white dark:bg-sleap-gray-950 bg-clip-padding">
      <div
        className="relative w-full max-w-[1158px] h-[609px] aspect-[3/4] md:aspect-[1158/609] rounded-2xl overflow-hidden"
        style={{ position: "relative" }}
      >
        {/* Mobile Image */}
        <img
          className="w-full h-full object-contain rounded-2xl block md:hidden"
          style={{
            objectPosition: "center",
            position: "absolute",
            top: 0,
            left: 0,
          }}
          src="/assets/v2/images/Flightshomepage3.png"
          alt={t("mobileAlt")}
        />

        {/* Desktop Image */}
        <img
          className="w-full h-full object-cover rounded-2xl hidden md:block"
          style={{
            objectPosition: "100% 50%",
            position: "absolute",
            top: 0,
            left: 0,
          }}
          src="/assets/v2/images/Flightshomepage2.png"
          alt={t("desktopAlt")}
        />

        {/* Text Content */}
        <div className="absolute inset-0 flex flex-col md:flex-row items-center md:items-center justify-start md:justify-end gap-6 md:gap-8 px-4 md:px-8">
          <div className="flex flex-col items-center justify-start gap-4 md:gap-6 w-full md:w-1/2 md:ml-auto md:pr-0 md:-mr-12 pt-4 md:pt-0">
            <h1 className="text-center text-2xl sm:text-3xl md:text-4xl font-semibold font-inter leading-[1.3] max-w-[90%] md:max-w-[332px] text-white">
              {t("title")}
            </h1>
            <p className="text-center text-xs sm:text-sm md:text-base font-normal font-inter leading-5 max-w-[80%] md:max-w-[248px] text-white">
              {t("description")}
            </p>
            <Link
              className="w-48 h-12 px-6 py-2.5 bg-gradient-to-br from-cyan-300 to-violet-500 rounded-lg inline-flex justify-center items-center gap-1 text-white text-sm font-semibold font-inter leading-tight"
              aria-label={t("buttonAria")}
              href="/points"
            >
              {t("buttonText")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

PointsSection.propTypes = {
  theme: PropTypes.oneOf(["light", "dark"]),
};

export default PointsSection;
